import { BaseEvent } from "@/api/ws/events/BaseEvent";

export default class ApplicationWasUpdatedEvent extends BaseEvent<{ id: string }> {
  name = "BorrowerPlatform\\ApplicationWasUpdated";
}
